module.exports = __webpack_public_path__ + "img/2.18fc656d.png";